<template>
  <el-popover v-if="isMobile && isEn" trigger="manual" :placement="popPosition" v-model="isShow" popper-class="jom-refer-info">
    <div style="word-wrap: break-word;width: 600px" class="mobile-div">
      <p v-for="item in transResult">{{item.dst}}</p>
    </div>
    <i class="el-icon-close" @click="closePopover()"></i>
    <div :class="{'translate-btn':true,'forbidden-click':isLoading}" slot="reference" ref="sup" @click="doTranslate()">译</div>
  </el-popover>
  <el-popover v-else-if="isEn" trigger="manual" :placement="popPosition" v-model="isShow" popper-class="jo-refer-info">
      <div style="word-wrap: break-word;width: 600px">
        <p v-for="item in transResult">{{item.dst}}</p>
      </div>
      <i class="el-icon-close" @click="closePopover()"></i>
      <div :class="{'translate-btn':true,'forbidden-click':isLoading}" slot="reference" ref="sup" @click="doTranslate()">译</div>
  </el-popover>
</template>

<script>
  import { MD5 } from '../common/md5.js'
  export default {
    components: {

    },
    props: [
      'data',
      'hideVocab'
    ],
    data(){
      return {
        originStr: '',
        transResult: [],
        errorMsg: '',
        isShow: false,
        isEn: true,
        popPosition: 'top',
        isLoading: false,
        isMobile: false
      }
    },
    created(){
      if (Array.isArray(this.data)){
        this.getText(this.data);
      } else if (this.data && this.data.length > 0){
        this.originStr = this.data;
      }
      let len = 0;
      for (let i=0; i<this.originStr.length; i++) {
        let c = this.originStr.charCodeAt(i);
        //单字节加1
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
          len++;
        }
      }
      this.isEn = len/this.originStr.length > 0.8
      if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
        this.isMobile = true;
      }
    },
    methods: {
      doTranslate() {
        if (this.isShow) {
            this.isShow = false;
            return;
        }
        this.isLoading = true;
        let _this = this;
        let salt = (new Date).getTime();
        let appId = '20220812001304180';
        let key = 'RpQd3uGHI3Map1Nndx8U';
        let str1 = appId + this.originStr + salt +key;
        let sign = MD5(str1);
        $.ajax({
          type:"get",
          async:false,
          url:"https://fanyi-api.baidu.com/api/trans/vip/translate",
          dataType: 'jsonp',
          data: {
            from: "en",
            to: "zh",
            appid: appId,
            salt: salt,
            sign: sign,
            q: this.originStr,

          },
          success:function(json , status){
            _this.isShow = true;
            _this.isLoading = false;
            if ('success' === status) {
              _this.transResult = json.trans_result;
              window.onclick = function (e) {
                _this.isShow = false;
              }
            } else if (json.error_code){
              if (json.error_code === 52003){
                _this.errorMsg = "未授权用户"
              } else if (json.error_code === 52003){
                _this.errorMsg = "系统错误，请重试"
              }else {
                _this.errorMsg = "请求超时"
              }
            }
          },
          error:function(status){
            _this.errorMsg = "请求超时";
          }
        });
        if (this.$refs.sup) {
          if (this.$refs.sup.offsetLeft < 250) {
            this.popPosition = 'top-start';
          }
        }
      },
      getText(item) {
        for (let i = 0;i < item.length;i++) {
          if (Array.isArray(item[i])){
            this.getText(item[i])
          } else if (item[i].name === 'text') {
            this.originStr += item[i].data
          } else if(item[i].name === 'xref' && item[i].data.type!=='fn'){
            this.originStr += item[i].data.text
          } else if(item[i].name === 'inlineformula'){
            item[i].data.forEach((mathItem, mathIndex) => {
              if (mathItem.data && mathItem.data.math) {
                this.originStr += mathItem.data.math.replace(/<[^<>]+>/g,'');
              }
            })
          } else if (item[i].name !== 'inlinegraphic') {
            this.getText(item[i].data)
          }
        }
      },
      closePopover() {
        this.isShow = false;
      },
    }
  }
</script>
<style lang="scss" scoped>
  .translate-btn{
    display: inline-block;
    /*background-color: #00a2af;*/
    color: #fafafa;
    width: 16px;
    height: 16px;
    text-indent: 0;
    font-size: 8px;
    cursor: pointer;
    text-align: center;
    vertical-align: middle;
    line-height: 18px;
    border-radius: 3px;
    user-select: none;
  }
  .forbidden-click{
    pointer-events: none;
  }
  .el-icon-close {
    position: absolute;
    top: 0;
    right: 0;
    padding: 3px 3px 0 3px;
    background-color: #f8feff;
    cursor: pointer;
    border-radius: 5px;
    &:hover {
      color: #00a2b1;
    }
  }
  .mobile-div{
    width: 98% !important;
  }
</style>



// WEBPACK FOOTER //
// src/commonComponents/translator.vue